import { BrowserRouter, Route, Routes } from "react-router-dom";
import ForgotPassword from "./pages/reset-password/ForgotPassword";
import SignIn from "./pages/sign-in/SignIn";
import SignUp from "./pages/sign-up/SignUp";

const Router = () => {
  return (
    <BrowserRouter basename="/">
      <Routes>
        {/* <Route path="/" element={<Navigate to="/signin" replace />} /> */}
        <Route path="/" element={<SignIn />} />
        <Route path="/oauth" element={<SignIn />} />
        {/* <Route path="/signin" element={<SignIn />} /> */}
        <Route path="/signup" element={<SignUp />} />
        <Route path="/reset-password" element={<ForgotPassword />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
